import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
const NetworkBarLink = ({ label , icon: Icon , url , tabIndex , isSelected , isCollapsed , hasNewContent , betaBadge , className , menuItems , showTooltip  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(NetworkBarItem, {
        url: url,
        tooltipContent: t(`networkBar.navItems.${label}.tooltip`),
        icon: /*#__PURE__*/ React.createElement(Icon, {
            disableDefaultColors: true,
            size: IconSize.MEDIUM
        }),
        biData: {
            evid: BiEventType.NETWORK_BAR_NAV_CLICK,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0,
            is_expanded: isCollapsed ? 0 : 1
        },
        menuBiData: {
            evid: BiEventType.NETWORK_BAR_3DOTS_OPEN,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0
        },
        isSelected: isSelected,
        isCollapsed: isCollapsed,
        hasNewContent: hasNewContent,
        betaBadge: betaBadge,
        tabIndex: tabIndex,
        menuItems: menuItems,
        className: className,
        showTooltip: showTooltip,
        "aria-label": t(`networkBar.navItems.${label}`)
    }, t(`networkBar.navItems.${label}`));
};
NetworkBarLink.displayName = 'NetworkBarLink';
export default NetworkBarLink;
